$( document ).ready(function(){
  $('nav ul').slicknav();



  $('.label-hide').hide();

  $('.background-image').each(function() {
    var bg = $(this).attr('data-bg-src');

    if (typeof bg !== typeof undefined && bg !== false) {
      $(this).css('background-image','url(/images/bg/'+bg+')');
    }
  })

  $('.bxslider').bxSlider({
    auto: true,
		keyboardEnabled: true,
		adaptiveHeight: true,
		autoHover: true,
  });
})
